import {setCookie} from '../utils/cookie';
import {toggleClass, removeClass, addClass} from "../utils/classes";

const onClickHandler = (node) => {
    const changeCookie = () => {
        const name = node.getAttribute('data-cookie-name');
        const value = node.getAttribute('data-cookie-value');
        setCookie(name, value);

        const elem = document.getElementById('product-list');

        toggleClass(elem, 'grid', value === 'grid');

        const nodes = document.querySelectorAll('.js-set-cookie');

        [...nodes].forEach(e => removeClass(e, 'active'));
        addClass(node, 'active');
    };
    node.addEventListener('click', changeCookie);
};

export default function () {
    const nodes = document.querySelectorAll('.js-set-cookie');

    [...nodes].forEach(onClickHandler);
}



// WEBPACK FOOTER //
// ./src/components/ViewSelect.js